import * as React from 'react';

export function useSearchBar() {
    const [textSearch, setTextSearch] = React.useState<string>('');
    return {textSearch, setTextSearch};
}

export const SearchBar: React.FC<{
    placeHolder: string;
    input: string;
    onChangeInput: (input: string) => void;
}> = ({placeHolder, input, onChangeInput}) => {
    return (
        <div className="search-bar">
            <input
                type="text"
                className="input"
                placeholder={placeHolder + '…'}
                onChange={(e) => onChangeInput(e.target.value)}
                value={input}
            />
        </div>
    );
};

export function filterWithTextSearch<Entity extends {name: string}>(
    textSearch: string,
    entities: Entity[]
) {
    if (textSearch === '') {
        return entities;
    } else {
        return entities.filter((entityType) =>
            entityType.name.toLowerCase().includes(textSearch.toLowerCase())
        );
    }
}

export function selectWithTextSearch(
    textSearch: string,
    entities: {name: string}[],
    setSelectedEntity: (name: string) => void
) {
    if (textSearch === '') {
        return;
    }
    // Get list of entities whose name match exactly textSearch
    const exactMatches = entities.filter(
        (entityType) =>
            entityType.name.toLowerCase() === textSearch.toLowerCase()
    );

    // If at least an exact match is found,
    // select this exact match entity
    if (exactMatches.length > 0) {
        setSelectedEntity(exactMatches[0].name);
    } else {
        //Otherwise, get entities whose name partially match textSearch
        const partialMatches = filterWithTextSearch(textSearch, entities);

        // If exactly one entity is a partial match,
        // select this entity
        if (partialMatches.length === 1) {
            setSelectedEntity(partialMatches[0].name);
        }
    }
}
